import { useSearchParams, Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { loginURL } from '@/api/auth';
import { Spinner } from '@/components/Spinner';

/*
  Login — единственный публичный route. Кнопка "Войти через Google"
  ведёт на /auth/google/login?return_to=<откуда пришли>.

  Если уже залогинен — сразу редирект на главную (или return_to).
*/

export function Login() {
  const { state } = useAuth();
  const [params] = useSearchParams();
  const returnTo = params.get('return_to') ?? '/';
  const error = params.get('error');

  if (state.status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (state.status === 'authenticated') {
    return <Navigate to={returnTo} replace />;
  }

  return (
    <div className="grid min-h-screen place-items-center px-6">
      <div className="w-full max-w-sm rounded-xl border border-line bg-card p-8 shadow-sm">
        <div className="mb-6 flex items-center gap-3">
          <span className="grid size-9 place-items-center rounded-md bg-brand-accent text-base font-semibold text-white">
            K
          </span>
          <h1 className="text-lg font-semibold tracking-tight">Kaname Hub</h1>
        </div>

        <h2 className="text-base font-medium">Войти в платформу</h2>
        <p className="mt-1 text-sm text-fg-muted">
          Доступ только сотрудникам Baxet Group по корпоративному Google-аккаунту.
        </p>

        {error && (
          <div
            role="alert"
            className="mt-4 rounded-md border border-notice-error-light-line bg-notice-error-surface px-3 py-2 text-sm text-notice-error-text"
          >
            Не получилось загрузить сессию. Попробуй ещё раз.
          </div>
        )}

        <a
          href={loginURL(returnTo)}
          className="mt-6 flex w-full items-center justify-center gap-3 rounded-md bg-brand-accent px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-action active:bg-brand-action-pressed"
        >
          <GoogleMark />
          Войти через Google
        </a>

        <p className="mt-4 text-xs text-fg-subtle">
          Cookies должны быть включены. Используется HttpOnly session-cookie.
        </p>
      </div>
    </div>
  );
}

function GoogleMark() {
  // Минимальная Google "G" — inline SVG чтобы не тянуть лого-пакеты.
  return (
    <svg viewBox="0 0 48 48" className="size-4" aria-hidden="true">
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.4 29.4 4.5 24 4.5 12.7 4.5 3.5 13.7 3.5 25S12.7 45.5 24 45.5c11 0 20-7.9 20-20.5 0-1.5-.2-3-.4-4.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8c1.8-4.4 6.1-7.5 11.1-7.5 3.1 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.4 29.4 4.5 24 4.5 16.3 4.5 9.7 8.7 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 45.5c5.3 0 10.1-2 13.7-5.3l-6.3-5.3c-2 1.4-4.5 2.2-7.4 2.2-5.2 0-9.7-3.3-11.3-7.9l-6.6 5.1C9.6 41 16.2 45.5 24 45.5z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.8l6.3 5.3c-.4.4 6.5-4.7 6.5-14.1 0-1.5-.2-3-.4-4.5z"
      />
    </svg>
  );
}
